export default __webpack_public_path__ + "static/media/daohoa.ee21ef8d.png";